import { AfterViewInit, Component, OnInit } from "@angular/core";
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { take } from "rxjs/operators";

import { INavPill } from "../../../core/interfaces/nav-pill.interface";

import { ApplicationConstantsEnum } from "../../../core/enums/applications-constants.enum";
import { InitialNavPillsEnum } from "../../../core/enums/initial-nav-pills.enum";

import { InitialNavPillsService } from "../../../services/local/initial-nav-pills.service";
import { PayrollService } from "../../../services/local/payroll.service";
import { TealiumUtagService } from "../../../tealium/utag.service";

@Component({
  selector: "app-form-welcome",
  templateUrl: "./form-welcome.component.html",
  styleUrls: ["./form-welcome.component.scss"],
})
export class FormWelcomeComponent implements OnInit, AfterViewInit {
  captchaResponse: string;
  description: string;
  numberAttemptsError: number;
  steps: any;
  showFirstError: boolean;
  textFirstError: string;
  title: string;

  pills: INavPill[];
  formGroup: UntypedFormGroup;
  loadingCustomerButton: boolean;

  constructor(
    private reCaptchaV3Service: ReCaptchaV3Service,
    private router: Router,
    private payrollService: PayrollService,
    private initialNavPillsService: InitialNavPillsService,
    private tealiumUtagService: TealiumUtagService,
  ) {
    this.tealiumUtagService.setConfig({
      account: "adl",
      profile: "popular",
      environment: "prod",
    });
  }

  ngOnInit() {
    this.numberAttemptsError = 0;
    this.textFirstError =
      "No tenemos un proceso activo con esta cédula. Verifica el número que ingresaste";
    this.title = "Bienvenido";
    this.description = "Para continuar necesitamos que ingreses tu documento.";
    this.steps = {
      numberSteps: 2,
      stepActive: 0,
    };

    this.addPills();
    this.initForm();
  }

  ngAfterViewInit(): void {
    this.tealiumUtagService.view({
      tealium_event: "page_view",
      page_path: document.location.pathname,
    });
  }

  initForm() {
    this.formGroup = new UntypedFormGroup({});
    this.formGroup.addControl(
      "textDocumentCustomer",
      new UntypedFormControl("", Validators.required),
    );
    this.formGroup.addControl("valuePill", new UntypedFormControl());
  }

  async initRecaptcha() {
    await this.reCaptchaV3Service
      .execute("onInit")
      .toPromise()
      .then(
        (token: any) => {
          this.captchaResponse = token;
        },
        (error: any) => {
          // eslint-disable-next-line no-console
          console.log(`FormWelcome - recaptcha - Error`, JSON.stringify(error));
        },
      );
  }

  async continue() {
    this.loadingCustomerButton = true;
    await this.initRecaptcha();

    const userForm = this.formGroup.value;
    const userId = this.tealiumUtagService.managementUserId(
      this.tealiumUtagService.generateUserId(
        userForm.valuePill,
        userForm.textDocumentCustomer,
      ),
    );

    this.tealiumUtagService.link({
      tealium_event: "click",
      event_category: "carga_documentos",
      event_label: "continuar",
      userId: userId,
    });

    this.payrollService
      .validateClient({
        documentType: userForm.valuePill,
        documentNumber: userForm.textDocumentCustomer,
        recaptchaResponse: this.captchaResponse,
      })
      .subscribe(
        () => {
          this.router.navigate(["upload"]);
        },
        () => {
          this.loadingCustomerButton = false;
          this.validateError();
        },
      );
  }

  private validateError() {
    this.numberAttemptsError ===
    ApplicationConstantsEnum.NUMBER_ATTEMPTS_LOGIN_CUSTOMER_DESIGN
      ? this.router.navigate(["overflowerror"])
      : (this.showFirstError = true);

    this.numberAttemptsError++;

    this.formGroup.controls.textDocumentCustomer.valueChanges
      .pipe(take(1))
      .subscribe(() => (this.showFirstError = false));
  }

  private addPills() {
    this.pills = this.initialNavPillsService.getInitialNavPills(
      InitialNavPillsEnum.LOGIN_CUSTOMER,
    );
  }
}
